import { AppState } from '../../redux/initialStates/AppState';
import { RootState } from '../../redux/store';
import { CompanySettingsState, TaxesState } from './CompanySettingsState';

export const selectCompanySettingsState = (state: AppState): CompanySettingsState => state.companySettings;

export const selectTaxesState = (state: RootState): TaxesState => state.companySettings.smbTaxes;
